<div [ngClass]="{ 'p-1 p-sm-2 p-md-4 ': this.disableContentPadding === false }" class="site-wrapper">
  <div class="mb-3">
    <div class="row justify-content-between">
      <div class="col-4">
        @if (enableBackButton) {
        <dx-button (onClick)="triggerBack()" icon="back" text="{{ 'Back' | transloco }}"></dx-button>
        }
      </div>
      <div class="col-2 text-right" data-cy="site-edit-button">
        @if (enableEditButton) {
        <dx-button (onClick)="triggerCustomEdit()" icon="edit" text="{{ 'Edit' | transloco }}" type="default"></dx-button>
        }
      </div>
    </div>
  </div>
  <div class="mb-3">
    @if (enableCustomBackButton) {
    <dx-button (onClick)="triggerCustomBack()" icon="back" text="{{ 'Back' | transloco }}"></dx-button>
    }
  </div>
  <div class="mb-1"></div>
  @if (!disableHeadline) {
  <div
    [ngClass]="{
      headlineMargin: this.disableHeadlineMarginBottom === false,
      'd-flex': !buttonTemplate,
      'd-block': buttonTemplate
    }"
    class="site-headline d-flex justify-content-between {{
      breakpointForButtonTemplate ? 'd-' + breakpointForButtonTemplate + '-flex' : ''
    }}"
    style="margin-top: 0.25rem"
  >
    <h1 class="page-title m-0 d-inline-block" style="font-weight: normal; font-size: 1.75rem">
      {{ headline | transloco }}{{ translatedHeadline }}
    </h1>
    <div
      [ngClass]="{
        'mt-2': buttonTemplate
      }"
      class="d-flex align-items-center {{ breakpointForButtonTemplate ? 'mt-' + breakpointForButtonTemplate + '-0' : '' }}"
    >
      <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
    </div>
  </div>
  }
  <ng-content></ng-content>
</div>
